// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ul,
#history-list {
  list-style-type: none;
}

#history-list {
  margin: 0;
  padding: 0;
}
#history-list li {
  cursor: default;
}
#history-list li .nested {
  display: none;
}
#history-list li .hide {
  visibility: hidden;
}
#history-list li .mat-icon,
#history-list li o-orion-card {
  cursor: pointer;
}
#history-list li .active {
  display: block;
}
#history-list li .row {
  align-items: center;
  display: flex;
  flex-direction: row;
}
#history-list li .row .item {
  margin: 8px;
  width: 100%;
}
#history-list li .row .item ::ng-deep .mat-mdc-card {
  margin: 0;
}

.selected-node {
  cursor: default !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm5hdmlnYXRpb24tdHJlZS5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQUE7QUFDRjs7QUFFQTs7RUFFRSxxQkFBQTtBQUNGOztBQUVBO0VBQ0UsU0FBQTtFQUNBLFVBQUE7QUFDRjtBQUNFO0VBQ0UsZUFBQTtBQUNKO0FBQ0k7RUFDRSxhQUFBO0FBQ047QUFFSTtFQUNFLGtCQUFBO0FBQU47QUFHSTs7RUFFRSxlQUFBO0FBRE47QUFJSTtFQUNFLGNBQUE7QUFGTjtBQUtJO0VBQ0UsbUJBQUE7RUFDQSxhQUFBO0VBQ0EsbUJBQUE7QUFITjtBQUtNO0VBR0UsV0FBQTtFQUNBLFdBQUE7QUFMUjtBQU9RO0VBQ0UsU0FBQTtBQUxWOztBQVlBO0VBQ0UsMEJBQUE7QUFURiIsImZpbGUiOiJuYXZpZ2F0aW9uLXRyZWUuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyI6aG9zdCB7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG51bCxcbiNoaXN0b3J5LWxpc3Qge1xuICBsaXN0LXN0eWxlLXR5cGU6IG5vbmU7XG59XG5cbiNoaXN0b3J5LWxpc3Qge1xuICBtYXJnaW46IDA7XG4gIHBhZGRpbmc6IDA7XG5cbiAgbGkge1xuICAgIGN1cnNvcjogZGVmYXVsdDtcblxuICAgIC5uZXN0ZWQge1xuICAgICAgZGlzcGxheTogbm9uZTtcbiAgICB9XG5cbiAgICAuaGlkZSB7XG4gICAgICB2aXNpYmlsaXR5OiBoaWRkZW47XG4gICAgfVxuXG4gICAgLm1hdC1pY29uLFxuICAgIG8tb3Jpb24tY2FyZCB7XG4gICAgICBjdXJzb3I6IHBvaW50ZXI7XG4gICAgfVxuXG4gICAgLmFjdGl2ZSB7XG4gICAgICBkaXNwbGF5OiBibG9jaztcbiAgICB9XG5cbiAgICAucm93IHtcbiAgICAgIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAgZmxleC1kaXJlY3Rpb246IHJvdztcblxuICAgICAgLml0ZW0ge1xuICAgICAgICAvLyBSZW1vdmUgaW5uZXIgbWFyZ2luIHRvIHNldCBpdCBoZXJlIGJlY2F1c2Ugb2YgY2xpY2sgZnVuY3Rpb24gb24gbGlua0NhcmRDb21wb25lbnRcbiAgICAgICAgLy8gYXZvaWRpbmcgYSBsaW5rQ2FyZENvbXBvbmVudCBiaWdnZXIgdGhhbiBpdHMgPGE+PC9hPiBsaW5rXG4gICAgICAgIG1hcmdpbjogOHB4O1xuICAgICAgICB3aWR0aDogMTAwJTtcblxuICAgICAgICA6Om5nLWRlZXAgLm1hdC1tZGMtY2FyZCB7XG4gICAgICAgICAgbWFyZ2luOiAwO1xuICAgICAgICB9XG4gICAgICB9XG4gICAgfVxuICB9XG59XG5cbi5zZWxlY3RlZC1ub2RlIHtcbiAgY3Vyc29yOiBkZWZhdWx0ICFpbXBvcnRhbnQ7XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./apps/viewer/src/app/toc-items/historic-module/navigation-tree/navigation-tree.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;;AAEA;;EAEE,qBAAA;AACF;;AAEA;EACE,SAAA;EACA,UAAA;AACF;AACE;EACE,eAAA;AACJ;AACI;EACE,aAAA;AACN;AAEI;EACE,kBAAA;AAAN;AAGI;;EAEE,eAAA;AADN;AAII;EACE,cAAA;AAFN;AAKI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;AAHN;AAKM;EAGE,WAAA;EACA,WAAA;AALR;AAOQ;EACE,SAAA;AALV;;AAYA;EACE,0BAAA;AATF;AACA,otDAAotD","sourcesContent":[":host {\n  width: 100%;\n}\n\nul,\n#history-list {\n  list-style-type: none;\n}\n\n#history-list {\n  margin: 0;\n  padding: 0;\n\n  li {\n    cursor: default;\n\n    .nested {\n      display: none;\n    }\n\n    .hide {\n      visibility: hidden;\n    }\n\n    .mat-icon,\n    o-orion-card {\n      cursor: pointer;\n    }\n\n    .active {\n      display: block;\n    }\n\n    .row {\n      align-items: center;\n      display: flex;\n      flex-direction: row;\n\n      .item {\n        // Remove inner margin to set it here because of click function on linkCardComponent\n        // avoiding a linkCardComponent bigger than its <a></a> link\n        margin: 8px;\n        width: 100%;\n\n        ::ng-deep .mat-mdc-card {\n          margin: 0;\n        }\n      }\n    }\n  }\n}\n\n.selected-node {\n  cursor: default !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
